import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import { formatDateUz } from '../../utils/format';

const PAGE_TITLES = {
  '/':            { title: 'Dashboard',    sub: "Tizim ko'rinishi" },
  '/employees':   { title: 'Xodimlar',     sub: "Barcha xodimlar ro'yxati" },
  '/salaries':    { title: 'Oyliklar',     sub: "Maosh ma'lumotlari" },
  '/upload-logs': { title: 'Yuklash Logi', sub: "Excel yuklash tarixi" },
};

export default function Layout() {
  const location = useLocation();
  const info = PAGE_TITLES[location.pathname] || { title: 'Oylik Bot', sub: '' };
  const [collapsed, setCollapsed] = useState(false);
  const sidebarW = collapsed ? 64 : 220;

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar onCollapse={setCollapsed} />

      <div style={{
        marginLeft: sidebarW,
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        background: 'var(--bg-secondary)',
        transition: 'margin-left 0.22s cubic-bezier(0.4,0,0.2,1)',
      }}>
        {/* Topbar */}
        <header style={{
          height: 'var(--topbar-height)',
          background: 'var(--bg-primary)',
          borderBottom: '1px solid var(--border)',
          display: 'flex', alignItems: 'center',
          padding: '0 28px',
          position: 'sticky', top: 0, zIndex: 50,
          boxShadow: 'var(--shadow-sm)',
        }}>
          <div>
            <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 18, fontWeight: 700, lineHeight: 1.2 }}>
              {info.title}
            </h1>
            {info.sub && (
              <p style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 1 }}>{info.sub}</p>
            )}
          </div>

          <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{
              display: 'flex', alignItems: 'center', gap: 6,
              padding: '5px 12px', borderRadius: 99,
              background: 'var(--emerald-100)',
              fontSize: 12, fontWeight: 600, color: 'var(--emerald-500)',
            }}>
              <span style={{ width: 7, height: 7, borderRadius: '50%', background: 'var(--emerald-500)', display: 'inline-block' }} />
              Jonli
            </div>
            <div style={{
              fontSize: 12, color: 'var(--text-muted)',
              padding: '5px 12px', borderRadius: 99,
              background: 'var(--bg-secondary)',
              border: '1px solid var(--border)',
            }}>
              {formatDateUz(new Date())}
            </div>
          </div>
        </header>

        <main style={{ flex: 1, padding: '24px 28px' }}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
